import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    class: "main-content-container",
    "data-cy": "certifications-page"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col me-auto" };
const _hoisted_4 = {
    key: 0,
    class: "col-auto"
};
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col" };
const _hoisted_7 = { class: "table-responsive table-responsive-sm table-responsive-md" };
const _hoisted_8 = {
    class: "table table-bordered certifications",
    "data-cy": "certification-list"
};
const _hoisted_9 = { class: "link" };
const _hoisted_10 = { class: "color" };
const _hoisted_11 = { class: "controls" };
const _hoisted_12 = { class: "cert-desc" };
const _hoisted_13 = { class: "label label-info" };
const _hoisted_14 = { class: "desc" };
const _hoisted_15 = { class: "link" };
const _hoisted_16 = ["href", "title"];
const _hoisted_17 = { class: "color" };
const _hoisted_18 = { class: "controls" };
const _hoisted_19 = { class: "btn-group" };
const _hoisted_20 = ["title", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["EditCertification"], {
            ref: "editCertification",
            onUpdated: $setup.refetchCertifications
        }, null, 512),
        _createVNode($setup["BContainer"], { fluid: "" }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS')), 1)
                    ]),
                    ($setup.certificationsLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode($setup["Loading"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("table", _hoisted_8, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_LABEL')), 1),
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_DESCRIPTION')), 1),
                                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_SLUG')), 1),
                                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_LINK')), 1),
                                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_BADGE_OUTPUT')), 1),
                                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('JTADM_CERTIFICATIONS_CONTROLS')), 1)
                                    ])
                                ]),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.certifications, (certification) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: certification.id
                                        }, [
                                            _createElementVNode("td", null, _toDisplayString(certification.label), 1),
                                            _createElementVNode("td", _hoisted_12, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certification.description, (value, key) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: "desc-holder",
                                                        key: key
                                                    }, [
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString(key), 1),
                                                        _createElementVNode("span", _hoisted_14, _toDisplayString(value), 1)
                                                    ]));
                                                }), 128))
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(certification.slug), 1),
                                            _createElementVNode("td", _hoisted_15, [
                                                (certification.link)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: $setup.generateLink(certification.link),
                                                        title: $setup.generateLink(certification.link)
                                                    }, "URL", 8, _hoisted_16))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("td", _hoisted_17, [
                                                _createElementVNode("div", null, [
                                                    _createVNode($setup["CertificationTag"], {
                                                        classes: "small",
                                                        certification: certification
                                                    }, null, 8, ["certification"])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _createElementVNode("button", {
                                                        class: "btn btn-small btn-warning",
                                                        title: _ctx.$t('JTADM_CERTIFICATIONS_EDIT'),
                                                        onClick: ($event) => ($setup.edit(certification))
                                                    }, [...(_cache[0] || (_cache[0] = [
                                                            _createElementVNode("i", { class: "dripicons-pencil" }, null, -1)
                                                        ]))], 8, _hoisted_20)
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ])
                    ])
                ])
            ]),
            _: 1
        })
    ]));
}
